import { Injectable } from '@angular/core';
import { DialogStateService } from '../../dialogs/services/dialog-state.service';
import { AB_SHOW_SESSION_EXPIRY_POPUP } from '../../shared/constants';
import { UserService } from '../../shared/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class ExpiryPopupService {
  private popupId = 'session';
  private timeout: any;
  private popupIsOpen = false;

  constructor(
    private dialogStateService: DialogStateService,
    private userService: UserService
  ) {
    this.userService.initOpenPopUp(() => this.openSessionPopup());
  }

  public startPopupTimer(stopTimer?: boolean) {
    if (stopTimer && this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => {
      this.openSessionPopup();
    }, AB_SHOW_SESSION_EXPIRY_POPUP * 60000);
  }

  public openSessionPopup() {
    console.log('session popup is opening');
    if (
      this.popupIsOpen ||
      !this.dialogStateService.checkIfPopupExists('session')
    ) {
      console.log(
        `Session popup is opened already. Flag is: ${this.popupIsOpen}`
      );
      return;
    }

    console.log('session popup is opened');
    this.dialogStateService.openDialog(this.popupId).subscribe(() => {
      console.log('session popup is closed');
      this.userService.logoutUser();
      this.popupIsOpen = false;
    });
    this.popupIsOpen = true;
  }
}
